import { OutfitNamesConstants } from "../Constants/OutfitNamesConstants";
import { StopperNamesConstants } from "../Constants/StopperNamesConstants";
import { ObjectPool } from "../Utils/ObjectPool";
import { CollisionSubjectModel } from "./BgContainerModels/CollisionSubjectModel/CollisionSubjectModel";
import { OutfitCollisionModel } from "./BgContainerModels/CollisionSubjectModel/OutfitCollisionModel";
import { StopperCollisionModel } from "./BgContainerModels/CollisionSubjectModel/StopperCollisionModel";
export interface IBgCollisionContainerPoolConfig {
    type: 'stopper' | 'outfit',
    name: StopperNamesConstants | OutfitNamesConstants
}
export class BgCollisionContainerModel {
    public readonly predictionDistance = 10000; // px
    public collisionSubject: CollisionSubjectModel[] = [];
    public speed: number = 700;
    public stopperPool: ObjectPool<CollisionSubjectModel> = new ObjectPool((cfg: IBgCollisionContainerPoolConfig) => {
        return new StopperCollisionModel();
    });
    public outfitPool: ObjectPool<CollisionSubjectModel> = new ObjectPool((cfg: IBgCollisionContainerPoolConfig) => {
        return new OutfitCollisionModel();
    });
    // public pool: ObjectPool<CollisionSubjectModel> = new ObjectPool((cfg: IBgCollisionContainerPoolConfig) => {
    //     let model;
    //     if(cfg.type === 'stopper') {
    //         model = new StopperCollisionModel();
    //     } else {
    //         model = new OutfitCollisionModel();
    //     }

    //     return model;
    // });


    constructor() {

    }
}